import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import CustomModal from "../Modal/CustomModal";
import { useDispatch, useSelector } from "react-redux";
import sampleImage from "../../assets/service_unavailable.png"
import {
  setServiceAlertModalDate,
  setServiceAlertPopupVisible,
} from "#src/modules/reducers/serviceAlert/actions.js";

const ServiceAlert = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isVisible = useSelector((state) => state.serviceAlert.popupVisible);
  const modalDate = useSelector((state) => state.serviceAlert.modalDate);
  const manualOperation = useSelector((state) => state.checkArsStatus.manualOperation);

  const updateVisibility = useCallback(() => {
    const today = new Date().toLocaleDateString();
    if (modalDate !== today && manualOperation === true) {
      dispatch(setServiceAlertPopupVisible({ popupVisible: true }));
    }
  }, [manualOperation]);

  useEffect(() => {
    updateVisibility();

    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        location.pathname === "/landing"
      ) {
        updateVisibility();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location.pathname, updateVisibility, manualOperation]);

  const handleClose = useCallback((hideForToday) => {
    dispatch(setServiceAlertPopupVisible({ popupVisible: false }));

    if (hideForToday) {
      const today = new Date().toLocaleDateString();
      dispatch(setServiceAlertModalDate({ modalDate: today }));
    }
  }, []);

  const [paddingTop, setPaddingTop] = useState("141.4%"); // A2 비율
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1600) {
        setPaddingTop("35%"); // PC 버전
      } else if (window.innerWidth >= 640) {
        setPaddingTop("90%");
      } else if (window.innerWidth >= 380) {
        setPaddingTop("141.4%");
      } else {
        setPaddingTop("100%");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // 초기 로드 시 호출

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <CustomModal
      isOpen={isVisible && manualOperation}
      onRequestClose={() => dispatch(setServiceAlertPopupVisible({ popupVisible: false }))}
      modalBottom
    >
      <div className="w-full">
        <div style={{ paddingTop }} className="relative overflow-hidden pb-4">
          <img
            src={sampleImage}
            alt="채팅 상담 사용 불가 안내"
            className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
      <div className="w-full flex items-center justify-end gap-2 mt-4">
        <PopupButton
          onClick={() => handleClose(true)}
          label="오늘 하루 보지 않기"
        />
        <PopupButton onClick={() => handleClose(false)} label="닫기" />
      </div>
    </CustomModal>
  );
};

const PopupButton = ({ onClick, label }) => (
  <button
    className="w-full py-3 text-sm font-semibold bg-white border rounded-2xl border-neutral-300"
    onClick={onClick}
  >
    {label}
  </button>
);

export default ServiceAlert;
